/** String operations (strcat/strlen/substr/strcase/ascii/chr). */

import { LispError } from '../errors';
import { NIL, mkInt, mkStr, strVal, type LispRuntimeApi, type LispValue } from '../values';
import { define, expectString } from './internal';

export function registerString(rt: LispRuntimeApi): void {
    define(rt, 'strcat', (args) => mkStr(args.map((a) => strVal(a)).join('')));
    define(rt, 'strlen', (args) => mkInt(strVal(args[0] ?? NIL).length));
    define(rt, 'substr', (args) => {
        const s = expectString(args[0] ?? NIL, 'substr');
        const start = Number(
            args[1] && (args[1].k === 'int' || args[1].k === 'real') ? args[1].v : NaN
        );
        if (!Number.isFinite(start)) throw new LispError('substr: bad argument type');
        const from = Math.max(0, Math.trunc(start) - 1);
        const lenArg = args[2];
        if (lenArg === undefined || lenArg.k === 'nil') {
            return mkStr(s.slice(from));
        }
        const len = lenArg && (lenArg.k === 'int' || lenArg.k === 'real') ? Math.trunc(lenArg.v) : 0;
        return mkStr(s.slice(from, from + Math.max(0, len)));
    });
    define(rt, 'strcase', (args) => {
        const s = expectString(args[0] ?? NIL, 'strcase');
        const lower = args[1] !== undefined && args[1].k !== 'nil';
        return mkStr(lower ? s.toLowerCase() : s.toUpperCase());
    });
    define(rt, 'ascii', (args) => {
        const s = strVal(args[0] ?? NIL);
        return mkInt(s.length > 0 ? s.charCodeAt(0) : 0);
    });
    define(rt, 'chr', (args) => {
        const code = args[0] && (args[0].k === 'int' || args[0].k === 'real') ? Math.trunc(args[0].v) : 0;
        if (code < 0 || code > 65535) throw new LispError('chr: bad argument');
        return mkStr(String.fromCharCode(code));
    });
}
